import type { V3Models } from "@istari/istari-client";

import { forgetUpload, subscribeUploadSessionClear, type UploadSnapshot } from "../data-source/upload-payloads";

export type FileUploadState = UploadSnapshot["state"];

export function fileUploadState(file: UploadingFile): FileUploadState {
  return file.snapshot?.state ?? file.state;
}
export type UploadingFile = {
  displayName: string;
  extension: string;
  externalIdentifier: string;
  tags: string[];
  resourceType: V3Models.ResourceCreateTypeDto;
  infosecLevelId?: string | null;
  id: string;
  state: FileUploadState;
  snapshot?: UploadSnapshot;
  originPath: string | null;
  serverFileId?: string;
  resourceId?: string;
  fileRevisionId?: string;
  errorMessage?: string;
};
export type UploadProgress = {
  files: UploadingFile[];
  completedCount: number;
  totalCount: number;
  overallState: "uploading" | "success" | "error" | "partial" | "cancelled";
};

export const retryOperations = new Map<string, () => Promise<unknown>>();

export function getUploadBatch() {
  return batch;
}

export function subscribeUploadBatch(listener: () => void) {
  listeners.add(listener);
  listener();
  return () => {
    listeners.delete(listener);
  };
}

export function startUploadBatch() {
  if (!batch) batch = { id: Math.random().toString(36).substring(2, 11), progress: null };
  return batch.id;
}

export function setUploadBatchProgress(progress: UploadProgress) {
  if (!batch) return;
  batch = { ...batch, progress };
  listeners.forEach((listener) => listener());
}

export function dismissUploadBatch() {
  if (batch?.progress?.overallState === "uploading") return;
  batch?.progress?.files.forEach((file) => {
    forgetUpload(file.id);
    retryOperations.delete(file.id);
  });
  resetUploadBatch();
}

export function resetUploadBatch() {
  batch = null;
  retryOperations.clear();
  listeners.forEach((listener) => listener());
}

let batch: { id: string; progress: UploadProgress | null } | null = null;
const listeners = new Set<() => void>();
window.addEventListener("pagehide", () => retryOperations.clear());
subscribeUploadSessionClear(resetUploadBatch);
